<template>
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    :dialogVisible="isOpen"
    @closed="onClosed"
    noInnerPadding
    hideCloseButton
  >
    <OrderDetails :orderData="orderData" @close="close" />
  </DialogComponent>
</template>

<script setup>
import { ref, onUnmounted } from 'vue'
import OrderDetails from './OrderDetails.vue'
import { bus } from '@core/events/eventSystem'
import constants from '@core/utils/constants'

const dialog = ref(null)
const orderData = ref(null)
const isOpen = ref(false)

let orderPollInterval = null

function startPolling() {
  stopPolling()
  const orderId = orderData.value?.id
  if (!orderId) return

  // Immediate fetch
  bus.emit(constants.EVENTS.ORDERS.DETAIL, orderId)

  // Then every 5s
  orderPollInterval = setInterval(() => {
    const id = orderData.value?.id
    if (!id) return
    bus.emit(constants.EVENTS.ORDERS.DETAIL, id)
  }, 5000)
}

function stopPolling() {
  if (orderPollInterval) {
    clearInterval(orderPollInterval)
    orderPollInterval = null
  }
}

// When controller responds, update local orderData if it's the same order
bus.on(constants.EVENTS.ORDERS.DETAIL_LOADED, (updatedOrder) => {
  if (updatedOrder?.id && orderData.value?.id === updatedOrder.id) {
    orderData.value = updatedOrder
  }
})

function showDetails(data) {
  orderData.value = data
  isOpen.value = true
  startPolling()
}

function close() {
  isOpen.value = false
  stopPolling()
}

const onClosed = () => {
  isOpen.value = false
  stopPolling()
}

onUnmounted(() => {
  stopPolling()
})

defineExpose({
  showDetails
})
</script>
